// Puente entre el interceptor de axios (fuera de React) y la UI de DVA.
const EVENT_NOTE_REQUEST = "arkadu:dva-note-request";
const EVENT_PENDING_NOTICE = "arkadu:dva-pending-notice";

let counter = 0;
const resolvers = new Map();

export const DVA_EVENTS = {
  NOTE_REQUEST: EVENT_NOTE_REQUEST,
  PENDING_NOTICE: EVENT_PENDING_NOTICE,
};

// Pide al usuario un mensaje para la solicitud DVA; resuelve null si cancela.
export const requestDvaNote = (meta = {}) => {
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }

  const id = `dva-note-${Date.now()}-${counter++}`;
  return new Promise((resolve) => {
    resolvers.set(id, resolve);
    window.dispatchEvent(
      new CustomEvent(EVENT_NOTE_REQUEST, { detail: { id, meta } }),
    );
  });
};

export const resolveDvaNote = (id, note) => {
  const resolver = resolvers.get(id);
  if (resolver) {
    resolver(note);
    resolvers.delete(id);
  }
};

export const notifyDvaPending = (payload) => {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(EVENT_PENDING_NOTICE, { detail: payload }),
  );
};
